import { Form, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import './styles/shareModal.css'
import {
  Facebook,
  Instagram,
  Linkedin,
  Telegram,
  Whatsapp,
  X,
} from '../../../../media/images/shareModal/index.js'
import Iccopy from '../../../../media/EarlyAccess/ic-copy.svg'
import { useThemeMode } from '../../../../_metronic/partials'
import { ToolTipUIForModal } from './UI/ToolTipUIForModal'

export default function ShareModal({ isActive, setIsActive, url }: any) {
  const { formatMessage } = useIntl()
  const link = url
  const { mode } = useThemeMode()

  function handleSocialShare(platform: string) {
    let message = ''
    let url = '' // Define platform-specific share URLs
    switch (platform) {
      case 'facebook':
        url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(message + link)}`
        break
      case 'instagram':
        url = `https://www.instagram.com/recordskeeper.ai/sharer.php?u=${encodeURIComponent(message + link)}`
        break
      case 'twitter':
        url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(message + link)}`
        break
      case 'linkedin':
        url = `https://www.linkedin.com/shareArticle?url=${encodeURIComponent(message + link)}`
        break
      case 'whatsapp':
        url = `https://api.whatsapp.com/send?text=${encodeURIComponent(message + link)}`
        break
      case 'telegram':
        url = `https://telegram.me/share/url?url=${encodeURIComponent(message + link)}`
        break
      default:
        return
    }
    window.open(url, '_blank')
  }

  return (
    <>
      <Modal
        show={isActive}
        onHide={() => {
          setIsActive(false)
        }}
      >
        <Form>
          <Modal.Header closeButton>
            <h2>{formatMessage({ id: 'Share' })}</h2>
          </Modal.Header>
          <Modal.Body>
            <div className='mb-5 mt-0'>
              <h1 className={`share-desc ${mode === 'dark' ? 'text-white' : ''}`}>
                {formatMessage({ id: 'Easily share this file with others' })}
              </h1>
            </div>
            <div className='social-outer-container'>
              <button className='social-container' onClick={() => handleSocialShare('facebook')}>
                <img src={Facebook} alt='facebook-icon' />
              </button>
              <button className='social-container' onClick={() => handleSocialShare('instagram')}>
                <img src={Instagram} alt='instagram-icon' />
              </button>
              <button className='social-container' onClick={() => handleSocialShare('linkedin')}>
                <img src={Linkedin} alt='linkedin-icon' />
              </button>
              <button className='social-container' onClick={() => handleSocialShare('twitter')}>
                <img src={X} alt='twitter-icon' />
              </button>
              <button className='social-container' onClick={() => handleSocialShare('whatsapp')}>
                <img src={Whatsapp} alt='whatsapp-icon' />
              </button>
              <button className='social-container' onClick={() => handleSocialShare('telegram')}>
                <img src={Telegram} alt='telegram-icon' />
              </button>
            </div>
            <div className='mb-4 mt-8'>
              <div className='d-flex align-items-center mb-1'>
                <p className={`font-size-13 m-0 ${mode === 'dark' ? 'text-white' : 'text-dark'}`}>{formatMessage({ id: 'Referral Link' })}</p>
                <ToolTipUIForModal tooltipText={'Share this unique link to invite others. Each successful referral moves you up the waitlist - invite 1 user to jump 50 spots, or invite 10+ users for priority access. Track your referrals in real-time below.'} />
              </div>
            </div>
            <div className='d-flex text-dark gap-4 align-items-center justify-content-between rounded-2 bg-white border border-1'
              style={{ color: '#33353A', background: '#FFFFFF' }}
            >
              <input
                type='text'
                className={`p-4 border border-0 w-100 bg-white rounded-2 ${mode === 'dark' ? 'text-white' : ''}`}
                value={url}
                placeholder={formatMessage({ id: 'Some path' })}
                readOnly
              />
              <span
                className='px-2 cursor-pointer bg-white'
                onClick={() => {
                  navigator.clipboard.writeText(
                    `${url}`
                  )
                  toast.success(formatMessage({ id: 'Copied Successfully' }))
                }}
              >
                <img src={Iccopy} alt='' />
              </span>
            </div>
          </Modal.Body>
        </Form>
      </Modal>
    </>
  )
}
